/************************************
MODULE:         Carousels
WHAT IT DOES:   initializes all carousels on the site except for tabs carousel on quote 2nd step, provides fallback for carousel height for non-flexbox browsers
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var opts = {
            dots: true,
            autoplay: false,
            autoplaySpeed: 4000,
            prevArrow: '<button class="slick-prev pt-carousel__prev js-sf-carousel-btn"><svg class="icon-arrow-thin-left"><use xlink:href="#icon-arrow-thin-left"></use></svg></button>',
            nextArrow: '<button class="slick-next pt-carousel__next js-sf-carousel-btn"><svg class="icon-arrow-thin-right"><use xlink:href="#icon-arrow-thin-right"></use></svg></button>'
        },
        timeout = null;

    function init() {
        initTabs();
        $(window).off('carousels:init');
        $(window).on('carousels:init', initTabs);
        if (!$('html').hasClass('flexbox')) {
            $(window).on('resize:finished', resizeCarousels);
        }
    }

    function resizeCarousels() {
        if (timeout)
            clearTimeout(timeout);
        var tracks = $('.js-sf-carousel .slick-track');
        if (!tracks.length)
            return;
        tracks.children().css('height', '');
        timeout = setTimeout(function () {
            for (var i = 0, l = tracks.length; i < l; i++) {
                var track = tracks.eq(i);
                track.children().css('height', track.parent().outerHeight());
            }
        }, 100);
    }

    function initTabs() {
        var carousels = $('.js-sf-carousel').not('.js-inited');
        if (!carousels.length)
            return;

        carousels.addClass('js-inited');

        require.ensure([], function () {
            
            var slick = require('slick');

            for (var i = 0, l = carousels.length; i < l; i++) {
                var carousel = carousels.eq(i),
                    currentOpts = $.extend({}, opts, {}),
                    dataAttributes = carousel.data();
    
                for (var attr in dataAttributes) {
                    currentOpts[attr] = dataAttributes[attr];
                }
    
               
                carousel.slick(currentOpts);
    
                if (carousel.parents('.tab_hide').length) {
                    carousel.slick('slickPause');
                }
    
                if (currentOpts.autoplay.toString() == "true") {
                    carousel.on('carousel:pause', carousel.slick.bind(carousel, 'slickPause'));
                    carousel.on('carousel:play', carousel.slick.bind(carousel, 'slickPlay'));
                }
            }
    
    
    
            $(document).off('click.sfcarousel');
            $(document).on('click.sfcarousel', '.js-sf-carousel-btn', carouselBtnClick);
            if (!$('html').hasClass('flexbox')){
                resizeCarousels();
            }

        }, 'slick');

    }

    function carouselBtnClick(e) {
        if (typeof e != 'undefined')
            e.preventDefault();
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.carousel.js
 ** module id = 34
 ** module chunks = 24
 **/